
export default {
    name: 'ThreeRowTable',
    props: {
        colhead: {
            type: Object,
            default() {
                return { head: ['01', '02', '03'], value: ['01', '02', '03'] }
            },
        },
        coldata: {
            type: Array,
            default() {
                return []
            },
        },
    },
}
